import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, vShow as _vShow, withCtx as _withCtx, createBlock as _createBlock, isRef as _isRef, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/zhongjian_ic_delete.png'
import _imports_1 from '@/assets/icon/jianyan_ic_saoma@2x.png'
import _imports_2 from '@/assets/icon/gongdan_ic_shoudong@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-10f89cc9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_h" }, null, -1))
const _hoisted_3 = { class: "page_lx_item padding" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "检验类型", -1))
const _hoisted_5 = { class: "page_lx_item_is" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_h" }, null, -1))
const _hoisted_8 = { class: "page_list_header" }
const _hoisted_9 = { class: "page_list_header_left" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_list_header_left_h" }, null, -1))
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "删除", -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { class: "page_list_item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "合格数量", -1))
const _hoisted_17 = { class: "page_list_item_ipt" }
const _hoisted_18 = ["onUpdate:modelValue"]
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "page_list_box" }
const _hoisted_21 = { class: "page_list_item1" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "不良数量", -1))
const _hoisted_23 = { class: "page_list_item_ipt" }
const _hoisted_24 = ["onUpdate:modelValue"]
const _hoisted_25 = { key: 0 }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "不良工装", -1))
const _hoisted_28 = { class: "page_content_item_is" }
const _hoisted_29 = { class: "page_content_sm" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "扫描工装", -1))
const _hoisted_33 = [
  _hoisted_31,
  _hoisted_32
]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "不良说明", -1))
const _hoisted_36 = { class: "page_content_item_is" }
const _hoisted_37 = { class: "page_list_add" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "page_remark" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_zw" }, null, -1))
const _hoisted_42 = { class: "page_footer" }
const _hoisted_43 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = { class: "result" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "result_title" }, "请确认检验数据", -1))
const _hoisted_47 = { class: "result_content" }
const _hoisted_48 = { class: "result_content_iten" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "检验率:", -1))
const _hoisted_50 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_51 = { class: "result_content_iten" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "不良率:", -1))
const _hoisted_53 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_54 = { class: "result_box" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "result_box_label" }, "检验结果", -1))
const _hoisted_56 = { class: "result_box_nr" }
const _hoisted_57 = ["onClick"]
const _hoisted_58 = { class: "result_footer" }
const _hoisted_59 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_60 = [
  _hoisted_59
]

import { ref, reactive, onMounted, nextTick, watch } from 'vue'
    import { useRoute, useRouter } from "vue-router"
    import { createJY, upload, uploadTest } from '@/apis/QualityAPI'
    import { Toast } from 'vant'
    import { QRCodeType, Attribute } from '@/enum'
    import { queryById, getListByCondition, checkAllList, getBarcodeContent, getEndCheckAP } from '@/apis/WorkOrderAPI'
    import VWorkOrderInfo from '@/components/common/WorkOrderInfo.vue'
    import Tooling from '@/components/common/Tooling.vue'

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const route = useRoute()

    const router = useRouter()

    // 区分扫码
    let index = ref<string>()

    let gzShow = ref<boolean>(false)

    // 区分插入数据
    let i = ref<number>()
    let ii = ref<number>()

    // 控制不良显示隐藏
    const isShow = ref<boolean>(false)

    // 控制扫码显示隐藏
    const openCode = ref<boolean>(false)

    // 提交弹框
    let subShow = ref<boolean>(false)

    // 工装弹框显示隐藏
    const show = ref<boolean>(false)

    // 不良原因弹框显示隐藏
    const show1 = ref<boolean>(false)

    // 工装下拉数据
    const columns: any = ref([])

    // 不良原因下拉数据
    const columns1: any = ref([])

    // 工单详情数据
    let info: any = ref({})

    let remark = ref<string>('')    // 备注

    // 工装器具详情
    let infos: any = ref({})

    // 搜索工装
    let value = ref<string>('')

    // 搜索工装暂存数据
    let dataList = ref<Array<object>>([])

    // 检验率/不良率
    let rate = reactive({
        inspectionRate: 0,
        defectiveRate: 0
    })

    // 检验提交数据
    let data: any = reactive([
        {
            gzid: '',   // 工装id
            gzbm: '',   // 工装编码
            gzmc: '',   // 工装名称
            total: 0,   // 工装总数
            qualified: '',   // 合格
            poorList: [   // 不良集合
                {
                    unqualified: '',      // 不合格
                    defectiveTooling: '',   // 不合格工装
                    defectiveToolingName: '',   // 不合格工装名称
                    defectDescription: '',  // 不合格说明
                }
            ],
            defectDescriptionName: ''  // 不良原因名称
        }
    ])

    // 检验类型
    const typeList: any = ref([
        { name: '检具检', active: true, id: 0 },
        { name: '外观检', active: false, id: 1 }
    ])

    // 类型
    const cate: any = ref([
        { name: '合格', active: true, id: 0 },
        { name: '不合格', active: false, id: 1 }
    ])

    // 添加不良工装
    const addItem = (i: number) => {
        data[i].poorList.push({
            unqualified: '',      // 不合格
            defectiveTooling: '',   // 不合格工装
            defectiveToolingName: '',   // 不合格工装名称
            defectDescription: '',  // 不合格说明
        })
    }

    const close1 = () => {
        gzShow.value = false
    }

    // 获取工装数据
    const getValue = (item: any) => {
        data[i.value as number].poorList[ii.value as number].defectiveTooling = item.id
        data[i.value as number].poorList[ii.value as number].defectiveToolingName = item.code
        gzShow.value = false
    }

    // 关闭统计弹框
    const close = () => {
        subShow.value = false
    }

    // 切换检验结果
    const chageCate = (i: number) => {
        cate.value.forEach((item: any, index: number) => {
            item.active = i === index;
        })
    }

    // 删除对应检验
    const dele = (index: number, i: number): void => {
        if (data[index].poorList.length === 1) {
            Toast.fail({ message: '至少需要一项内容' })
            return
        }
        data[index].poorList.splice(i, 1)
    }

    // 模糊搜索
    const changeValue = (val: any): void => {
        dataList.value = []
        let { _value } = val.target
        if (!_value) return
        columns.value.forEach((item: any) => {
            if (item.text.indexOf(_value) !== -1) {
                dataList.value.push(item)
            }
        })
    }

    // 获取扫码值
    const onDecode = (datas: string[]): void => {
        if (index.value === '1') {
            getBarcodeContent({
                barcode: datas[0]
            }).then(res => {
                if (res.code === 200) {
                    if (res.data.barcodeType === QRCodeType.GZ) {
                        getListByCondition({
                            id: res.data.id
                        }).then(res => {
                            if (res.code === 200 && res.data && res.data.length !== 0) {
                                if (info.value.type === 2) {    // 返工返修
                                    if (res.data[0].smodelLabel === Attribute.BF) {
                                        if (res.data[0].status !== 0) {
                                            data[i.value as number].poorList[ii.value as number].defectiveTooling = res.data[0].id
                                            data[i.value as number].poorList[ii.value as number].defectiveToolingName = res.data[0].code
                                        } else {
                                            Toast.fail({ message: '扫描的工装状态不能为已报废' })
                                        }
                                    } else {
                                        Toast.fail({ message: '只能扫描报废属性的工装' })
                                    }
                                } else {
                                    if (res.data[0].smodelLabel === Attribute.BL || res.data[0].smodelLabel === Attribute.BF) {
                                        if (res.data[0].status !== 0) {
                                            data[i.value as number].poorList[ii.value as number].defectiveTooling = res.data[0].id
                                            data[i.value as number].poorList[ii.value as number].defectiveToolingName = res.data[0].code
                                        } else {
                                            Toast.fail({ message: '扫描的工装状态不能为已报废' })
                                        }
                                    } else {
                                        Toast.fail({ message: '只能扫描不良或者报废属性的工装' })
                                    }
                                }
                            }
                        })
                    } else {
                        Toast.fail({ message: '请扫描正确的工装码' })
                    }
                }
            })
        } else if (index.value === '2') {
            getBarcodeContent({
                barcode: datas[0]
            }).then(res => {
                if (res.code === 200) {
                    if (res.data.barcodeType === QRCodeType.GZ) {
                        getEndCheckAP({
                            appliancesId: res.data.id,
                            workOrderId: route.query.gdId
                        }).then(res => {
                            if (res.code === 200) {
                                // if (res.data[0].workorderId === info.value.id) {
                                data.push({
                                    gzid: res.data.appliancesId,
                                    gzbm: res.data.appliancesCode,
                                    gzmc: '',
                                    total: res.data.appliancesNum,
                                    qualified: '',
                                    poorList: [   // 不良集合
                                        {
                                            unqualified: '',      // 不合格
                                            defectiveTooling: '',   // 不合格工装
                                            defectiveToolingName: '',   // 不合格工装名称
                                            defectDescription: '',  // 不合格说明
                                        }
                                    ],
                                    defectDescriptionName: ''
                                })
                                // } else {
                                //     Toast.fail({ message: '此工装不在当前工单下', duration: 2000 })
                                // }
                            }
                        })
                        // getListByCondition({
                        //     id: res.data.id
                        // }).then(res => {
                        //     if (res.code === 200 && res.data && res.data.length !== 0) {
                        //         // if (res.data[0].workorderId === info.value.id) {
                        //             data.push({
                        //                 gzid: res.data[0].id,
                        //                 gzbm: res.data[0].code,
                        //                 gzmc: res.data[0].mmodelName,
                        //                 total: res.data[0].num,
                        //                 qualified: '',
                        //                 unqualified: '',
                        //                 defectiveTooling: '',
                        //                 defectiveToolingName: '',
                        //                 defectDescription: '',
                        //                 defectDescriptionName: ''
                        //             })
                        //         // } else {
                        //         //     Toast.fail({ message: '此工装不在当前工单下', duration: 2000 })
                        //         // }
                        //     }
                        // })
                    } else {
                        Toast.fail({ message: '请扫描正确的工装码' })
                    }
                }
            })
        }
        nextTick(() => {
            openCode.value = false
        })
    }

    // 关闭扫码组件
    const closePopup = (): void => {
        openCode.value = false
    }

    // 确认选择工装
    const onConfirm = (value: any) => {
        data[i.value as number].defectiveTooling = value.id
        data[i.value as number].defectiveToolingName = value.text
        show.value = false
    }

    // 关闭工装弹框
    const onCancel = () => {
        show.value = false
    }

    // 确认选择不良原因
    const onConfirm1 = (value: any) => {
        data[i.value as number].poorList[ii.value as number].defectDescription = value.id
        data[i.value as number].poorList[ii.value as number].defectDescriptionName = value.text
        show1.value = false
    }

    // 关闭不良原因弹框
    const onCancel1 = () => {
        show1.value = false
    }

    // 打开工装
    const openGZ = (index: number, indexTow: number): void => {
        // show.value = true
        gzShow.value = true
        i.value = index
        ii.value = indexTow
    }

    // 继续检验
    const openSM = (type: string, Index: number, indexTwo: number): void => {
        i.value = Index
        ii.value = indexTwo
        index.value = type
        openCode.value = true
    }

    // 打开不良原因
    const openBL = (index: number, indexTwo: number): void => {
        i.value = index
        ii.value = indexTwo
        show1.value = true
    }

    // 切换类型
    const clickTag = (index: number): void => {
        typeList.value.forEach((item: any, i: number) => {
            item.active = index === i;
        })
    }

    // 获取工单详情
    const queryByIds = () => {
        queryById(route.query.gdId)
            .then(res => {
                if (res.code === 200) {
                    info.value = res.data
                    let router: any = route.query.type
                }
            })
    }

    // 查询工装器具详情
    const getListByConditions = (id: any): void => {
        getEndCheckAP({
            appliancesId: route.query.gzId,
            workOrderId: route.query.gdId
        }).then(res => {
            if (res.code === 200) {
                // infos.value = res.data[0]
                data[0].gzid = res.data.appliancesId
                data[0].gzbm = res.data.appliancesCode
                // data[0].gzmc = res.data[0].mmodelName
                data[0].total = res.data.appliancesNum
            }
        })
        // getListByCondition({
        //     id
        // }).then(res => {
        //     if (res.code === 200 && res.data && res.data.length !== 0) {
        //         infos.value = res.data[0]
        //         data[0].gzid = Number(id)
        //         data[0].gzbm = res.data[0].code
        //         data[0].gzmc = res.data[0].mmodelName
        //         data[0].total = res.data[0].num
        //     }
        // })
    }

    // 不良原因数据
    const checkAllLists = () => {
        checkAllList({ bmodelCateType: '3' })
            .then(res => {
                if (res.code === 200 && res.data && res.data.length !== 0) {
                    res.data.forEach((item: any) => {
                        columns1.value.push({ text: item.combinationName, id: item.id })
                    })
                }
            })
    }

    /***
     * 查询不良/报废工装
     * APPLIANCE_OFFTEST 不良
     * APPLIANCE_USELESS 报废
     * APPLIANCE_MIX 混合
     */
    const getListByConditions1 = () => {
        getListByCondition({
            smodelLabel: 'APPLIANCE_MIX'
        }).then(res => {
            if (res.code === 200 && res.data && res.data.length !== 0) {
                res.data.forEach((item: any) => {
                    columns.value.push({ text: item.code, id: item.id })
                })
            }
        })
    }

    // 数组分组
    const sortClass = (sortData: any): Array<any> => {
        const groupBy = (array: any, f: any) => {
            let groups: any = {};
            array.forEach((o: any) => {
                let group: any = JSON.stringify(f(o));
                groups[group] = groups[group] || [];
                groups[group].push(o);
            });
            return Object.keys(groups).map((group) => {
                return groups[group];
            });
        };
        const sorted = groupBy(sortData, (item: any) => {
            return item.gzbm; // 返回需要分组的对象
        });
        return sorted;
    }

    // 提交检验
    const submit = () => {
        let isOpen: boolean = true
        // 判断合格和不良加起来是否大于0
        let num: number = 0
        data.forEach((item: any) => {
            num = num + (item.qualified ? item.qualified : 0)
            item.poorList.forEach((element: any, i: number) => {
                num = num + (element.unqualified ? element.unqualified : 0)
                if (element.unqualified && element.unqualified > 0) {
                    if (element.defectiveTooling === '' || element.defectDescription === '') {
                        Toast.fail({ message: `工装[${item.gzbm}]不良说明或不良工装不能为空` })
                        isOpen = false
                        return;
                    }
                }
                if (i === item.poorList.length - 1) {
                    if (num === 0) {
                        Toast.fail({ message: `工装[${item.gzbm}]合格数量和不良数量不能同时为0` })
                        isOpen = false
                        return
                    }
                }
            })
        })
        let totalNum: number = 0
        data.forEach((element: any) => {
            totalNum = totalNum + (element.qualified ? element.qualified : 0)
            element.poorList.forEach((elementTwo: any) => {
                totalNum = totalNum + (elementTwo.unqualified ? elementTwo.unqualified : 0)
            })
        })
        if (totalNum > info.value.planNum) {
            Toast.fail({ message: '合格和不良总和不能大于工单计划数量' })
            return
        }
        // 数组分组
        // let res = sortClass(data)
        // console.log(res)
        // let total: number = 0
        // // 判断工装是否超出总数
        // res.forEach((item: any) => {
        //     let total: number = 0  // 工装总数
        //     let num: number = 0  // 已投入数量
        //     item.forEach((item1: any, index: number) => {
        //         total = item1.total
        //         num = num + (item1.qualified ? item1.qualified : 0) + (item1.unqualified ? item1.unqualified : 0)
        //         if (item.length - 1 === index) {
        //             if (num > total) {
        //                 Toast.fail({ message: `工装[${item1.gzbm}]已超出最大数量` })
        //                 isOpen = false
        //                 return
        //             }
        //         }
        //     })
        // })
        let total: number = 0   // 检验合格数量+检验不良数量
        let total1: number = 0   // 检验不良数量
        data.forEach((item: any) => {
            total = total + (item.qualified ? item.qualified : 0)
            item.poorList.forEach((element: any) => {
                total = total + (element.unqualified ? element.unqualified : 0)
                total1 = total1 + (element.unqualified ? element.unqualified : 0)
            })
        })
        rate.inspectionRate = (total / info.value.planNum * 100).toFixed(2) as any
        rate.defectiveRate = (total1 / total * 100).toFixed(2) as any
        if (isOpen) subShow.value = true
    }

    // 提交终检
    const submit1 = () => {
        let obj: any = {
            checkType: '',
            downType: '',
            num: 0,
            remark: remark.value,
            workOrderId: Number(route.query.gdId),
            endCheckDetailBeanList: []
        }
        typeList.value.forEach((item: any) => {
            if (item.active) {
                obj.checkType = item.id
            }
        })
        cate.value.forEach((item: any) => {
            if (item.active) {
                obj.downType = item.id
            }
        })
        data.forEach((item: any, index: number) => {
            obj.num = obj.num + (item.qualified ? item.qualified : 0)
            obj.endCheckDetailBeanList.push({
                appliancesId: item.gzid,
                appliancesNum: item.total,
                num: item.qualified ? item.qualified : 0,
                // checkInfo: '',
                // qualifiedAppliancesId: '',
                qualifiedNum: item.qualified ? item.qualified : 0,
                // unQualifiedNum: 0,
                endCheckUnQualifiedBeanList: []
            })
            item.poorList.forEach((element: any) => {
                obj.num = obj.num + (element.unqualified ? element.unqualified : 0)
                obj.endCheckDetailBeanList[index].num = obj.endCheckDetailBeanList[index].num + (element.unqualified ? element.unqualified : 0)
                // obj.endCheckDetailBeanList.unQualifiedNum = element.unqualified ? element.unqualified : 0
                // obj.endCheckDetailBeanList.qualifiedAppliancesId = element.defectiveTooling
                // obj.endCheckDetailBeanList.checkInfo = element.defectDescriptionName
                if (element.unqualified) {
                  obj.endCheckDetailBeanList[index].endCheckUnQualifiedBeanList.push({
                    checkInfo: element.defectDescriptionName,
                    qualifiedAppliancesId: element.defectiveTooling,
                    unQualifiedNum: element.unqualified
                  })
                }
            })
        })
        // console.log(obj)
        uploadTest(obj)
            .then(res => {
                if (res.code === 200) {
                    Toast.success({ message: '检验成功', duration: 2000, forbidClick: true })
                    setTimeout(() => {
                        router.go(-1)
                    }, 2000)
                }
            })
    }

    // 监听选择工装
    watch(() => show.value, (news, old) => {
        if (!news) {
            dataList.value = []
            value.value = ''
        }
    })

    const addNum = (num1: number, num2: number): number => {
        num1 == undefined ? num1 = 0 : ''
        num2 == undefined ? num2 = 0 : ''
        let sq1, sq2, m;
        try {
            sq1 = num1.toString().split(".")[1].length;
        } catch (e) {
            sq1 = 0;
        }
        try {
            sq2 = num2.toString().split(".")[1].length;
        } catch (e) {
            sq2 = 0;
        }
        m = Math.pow(10, Math.max(sq1, sq2));
        return (num1 * m + num2 * m) / m;
    }


    onMounted(() => {
        queryByIds()
        getListByConditions(route.query.gzId)
        checkAllLists()
        getListByConditions1()
    })

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_swipe_cell = _resolveComponent("van-swipe-cell")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_v_ScanCode = _resolveComponent("v-ScanCode")!
  const _directive_preventReClick = _resolveDirective("preventReClick")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(VWorkOrderInfo, { info: _unref(info) }, null, 8, ["info"]),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeList.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["page_lx_item_is_i", { 'active': item.active }]),
            key: index,
            onClick: ($event: any) => (clickTag(index))
          }, [
            _createElementVNode("span", null, _toDisplayString(item.name), 1)
          ], 10, _hoisted_6))
        }), 128))
      ])
    ]),
    _hoisted_7,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data), (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "page_list",
        key: index
      }, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("span", null, _toDisplayString(item.gzbm), 1)
          ]),
          _createElementVNode("div", {
            class: "page_list_header_right",
            onClick: ($event: any) => (dele(index))
          }, _hoisted_14, 8, _hoisted_11)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": ($event: any) => ((item.qualified) = $event),
              type: "number"
            }, null, 8, _hoisted_18), [
              [_vModelText, item.qualified]
            ]),
            (_unref(info).umodel)
              ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_unref(info).umodel.name), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.poorList, (childer, i) => {
          return (_openBlock(), _createBlock(_component_van_swipe_cell, { key: i }, {
            right: _withCtx(() => [
              _createVNode(_component_van_button, {
                style: {"height":"100%"},
                square: "",
                type: "danger",
                text: "删除",
                onClick: ($event: any) => (dele(index, i))
              }, null, 8, ["onClick"])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createElementVNode("div", _hoisted_23, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": ($event: any) => ((childer.unqualified) = $event),
                      placeholder: "0",
                      type: "number"
                    }, null, 8, _hoisted_24), [
                      [_vModelText, childer.unqualified]
                    ]),
                    (_unref(info).umodel)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_unref(info).umodel.name), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _withDirectives(_createElementVNode("div", {
                  class: "page_list_item1",
                  onClick: ($event: any) => (openGZ(index, i))
                }, [
                  _hoisted_27,
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("span", {
                      style: _normalizeStyle(childer.defectiveToolingName ? 'color: #000;' : '')
                    }, _toDisplayString(childer.defectiveToolingName ? childer.defectiveToolingName : '点击选择工装'), 5),
                    _createVNode(_component_van_icon, {
                      name: "arrow",
                      color: "#999999",
                      size: "18"
                    })
                  ])
                ], 8, _hoisted_26), [
                  [_vShow, childer.unqualified > 0]
                ]),
                _withDirectives(_createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", {
                    class: "page_content_sm_box",
                    onClick: ($event: any) => (openSM('1', index, i))
                  }, _hoisted_33, 8, _hoisted_30)
                ], 512), [
                  [_vShow, childer.unqualified > 0]
                ]),
                _withDirectives(_createElementVNode("div", {
                  class: "page_list_item1",
                  onClick: ($event: any) => (openBL(index, i))
                }, [
                  _hoisted_35,
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("span", {
                      style: _normalizeStyle(childer.defectDescriptionName ? 'color: #000;' : '')
                    }, _toDisplayString(childer.defectDescriptionName ? childer.defectDescriptionName : '点击选择不良原因'), 5),
                    _createVNode(_component_van_icon, {
                      name: "arrow",
                      color: "#999999",
                      size: "18"
                    })
                  ])
                ], 8, _hoisted_34), [
                  [_vShow, childer.unqualified > 0]
                ])
              ])
            ]),
            _: 2
          }, 1024))
        }), 128)),
        _createElementVNode("div", _hoisted_37, [
          _hoisted_38,
          _createElementVNode("span", {
            onClick: ($event: any) => (addItem(index))
          }, "添加不良", 8, _hoisted_39)
        ])
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_40, [
      _withDirectives(_createElementVNode("textarea", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(remark) ? (remark).value = $event : remark = $event)),
        placeholder: "请输入检验备注说明信息，非必填"
      }, null, 512), [
        [_vModelText, _unref(remark)]
      ])
    ]),
    _hoisted_41,
    _createElementVNode("div", _hoisted_42, [
      _createElementVNode("div", {
        class: "page_footer_jx",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (openSM('2')))
      }, "继续检验"),
      _withDirectives((_openBlock(), _createElementBlock("button", {
        class: "page_footer_tj",
        onClick: submit
      }, _hoisted_44)), [
        [_directive_preventReClick]
      ])
    ]),
    _createVNode(_component_van_popup, {
      show: show1.value,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((show1).value = $event)),
      position: "bottom",
      round: "",
      style: { height: '40%' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_picker, {
          title: "选择不良原因",
          columns: columns1.value,
          onConfirm: onConfirm1,
          onCancel: onCancel1
        }, null, 8, ["columns"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_v_ScanCode, {
      openCode: openCode.value,
      infos: ['请扫描工装码'],
      onClosePopup: closePopup,
      onOnDecode: onDecode
    }, null, 8, ["openCode"]),
    _createVNode(_component_van_popup, {
      show: _unref(subShow),
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => (_isRef(subShow) ? (subShow).value = $event : subShow = $event)),
      position: "bottom",
      round: "",
      style: { height: '40%' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_45, [
          _hoisted_46,
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, [
              _hoisted_49,
              _hoisted_50,
              _createElementVNode("span", null, _toDisplayString(_unref(rate).inspectionRate) + "%", 1)
            ]),
            _createElementVNode("div", _hoisted_51, [
              _hoisted_52,
              _hoisted_53,
              _createElementVNode("span", null, _toDisplayString(_unref(rate).defectiveRate) + "%", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_54, [
            _hoisted_55,
            _createElementVNode("div", _hoisted_56, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cate.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["result_box_nr_item", {'actives': item.active}]),
                  key: index,
                  onClick: ($event: any) => (chageCate(index))
                }, _toDisplayString(item.name), 11, _hoisted_57))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_58, [
            _createElementVNode("div", {
              class: "result_footer_qx",
              onClick: close
            }, "取消"),
            _withDirectives((_openBlock(), _createElementBlock("button", {
              class: "result_footer_qr",
              onClick: submit1
            }, _hoisted_60)), [
              [_directive_preventReClick]
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(Tooling, {
      show: _unref(gzShow),
      attribute: _unref(Attribute).HH,
      onClose: close1,
      onValue: getValue
    }, null, 8, ["show", "attribute"])
  ]))
}
}

})